import React from "react";
//#region types
import { WintSuperkollAPIModel as APIModels } from "wint-api-client/dist/types";
import { InvoicePaymentStatusProps } from "models/propTypes/invoicePropTypes";
import { IconDefinitionConstants } from "utils/constants";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Icon } from "components/common";
import { Grid, Tooltip } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const InvoicePaymentStatus: React.FC<InvoicePaymentStatusProps> = (props) => {
  const invoiceService = useInvoiceService();
  const getPaymentIcon = (status: APIModels.InvoicePaymentState) => {
    switch (status) {
      case APIModels.InvoicePaymentState.Paid:
        return { type: StyleEnums.DisplayType.Success, icon: IconDefinitionConstants.WValidateCheck };
      case APIModels.InvoicePaymentState.PartiallyPaid:
        return { type: StyleEnums.DisplayType.Warning, icon: IconDefinitionConstants.WValidateCheck };
      case APIModels.InvoicePaymentState.PartiallyPaidOverdue:
        return { type: StyleEnums.DisplayType.Danger, icon: IconDefinitionConstants.WValidateCheck };
      case APIModels.InvoicePaymentState.Overdue:
        return { type: StyleEnums.DisplayType.Danger, icon: IconDefinitionConstants.WExclamation };
      case APIModels.InvoicePaymentState.OverdueSoon:
        return { type: StyleEnums.DisplayType.Warning, icon: IconDefinitionConstants.WExclamation };
      default:
        return {};
    }
  };

  const paymentValues = getPaymentIcon(props.status);

  return paymentValues.icon ? (
    <Tooltip
      disableInteractive
      placement="top"
      title={invoiceService.getPaymentStateText(props.status)}
      classes={{ tooltip: cssExports.tooltip, popper: cssExports.tooltipPopper }}
    >
      <Grid item>
        <Icon icon={paymentValues.icon} className={cssExports.tableIcon} displayType={paymentValues.type} />
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default InvoicePaymentStatus;
